import {useFormik} from 'formik'
import {useEffect, useRef} from 'react'
import {createSearchParams, useNavigate} from 'react-router-dom'
import * as Yup from 'yup'
import {MenuComponent} from '../../../../_metronic/assets/ts/components'
import {KTSVG} from '../../../../_metronic/helpers'
import * as a from '../../../_ancientLibrary/components/'

type Props = {
  isLoading?: boolean
  formContent: any
  pathName: string
  initialValues?: any
}
type FieldWrapperProps = {
  label?: string
}

const editGroupSchema = Yup.object().shape({})

export const AncientListFilter: React.FC<Props> = ({
  isLoading,
  formContent,
  pathName,
  initialValues,
}) => {
  const navigate = useNavigate()
  const menuRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const formik = useFormik({
    initialValues: initialValues || {},
    validationSchema: editGroupSchema,
    enableReinitialize: true,
    onSubmit: async (values: any, {setSubmitting}) => {
      navigate({pathname: pathName, search: `?${createSearchParams(values)}`})
      if (menuRef.current) {
        menuRef.current.classList.remove('show')
      }
      setSubmitting(false)
    },
  })

  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-primary me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
        Filter
      </button>
      <div
        className='menu menu-sub menu-sub-dropdown w-300px w-md-325px'
        data-kt-menu='true'
        ref={menuRef}
      >
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
        </div>
        <div className='separator border-gray-200'></div>
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          <form id='ancient-list-filter' className='form' onSubmit={formik.handleSubmit} noValidate>
            {formContent(formik)}
            <div className='d-flex justify-content-end'>
              <a.AncientButtonSubmit
                displayText='Apply'
                submitting={false}
                disabled={false}
                className={'btn btn-primary fw-bold px-6'}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
export const AncientListFilterFieldWrapper: React.FC<FieldWrapperProps> = ({children, label}) => {
  return (
    <>
      <div className='mb-10'>
        <label className='form-label fs-6 fw-bold'>
          {label != undefined ? label : <>&nbsp;</>}
        </label>
        {children}
      </div>
    </>
  )
}
